import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Wrapper, PageContent, Title, Anchor, SubtitlePlaceholder, Subtitle } from './SignUpPage.style';

import Placeholder from '../../../components/Placeholder';

const image = {
  title: 'Seminar Photo Gallery',
  description: 'Seminar Photo Gallery',
  file: {
    url:
      'https://images.ctfassets.net/qf666eyypqhw/1qanwtJ3SEuKSuiiKkIaYQ/a1f2dcc94b1ee96288c60e58dac36b19/pattern.jpg',
    details: { size: 3813, image: { width: 900, height: 1024 } },
    fileName: 'stylist_tool_login_pattern.jpg',
    contentType: 'image/jpeg',
  },
};

const SignedUp = ({ copy, locale }) => (
  <Wrapper bg={image.file.url} w={image.file.details.image.width}>
    <PageContent>
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Title>{copy.sign_up_thank}</Title>
      ) : (
        <div>
          <Placeholder h="40px" w="500px" />
        </div>
      )}
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Subtitle>{copy.check_email}</Subtitle>
      ) : (
        <SubtitlePlaceholder>
          <Placeholder h="24px" w="400px" />
        </SubtitlePlaceholder>
      )}
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Link to={`/${locale}/stylist/login`} href={`/${locale}/stylist/login`}>
          <Anchor style={{ marginLeft: 0 }}>{copy.start_learning}</Anchor>
        </Link>
      ) : (
        <div>
          <Placeholder h="25px" w="250px" />
        </div>
      )}
    </PageContent>
  </Wrapper>
);

SignedUp.defaultProps = {
  copy: {},
};

SignedUp.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
};

export default SignedUp;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SignUpPage/SignedUp.js